import { useEffect, useRef } from "react";
import { ReactNode } from "react";
import { ChatCurrentMessagesArray } from "../models/chatbotModels";

type ChatbotScrollingConversationProps = {
  children: ReactNode;
  dependencies: [ChatCurrentMessagesArray, boolean];
};

export const ChatbotScrollingConversation = ({ children, dependencies }: ChatbotScrollingConversationProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  // UX scroll to bottom of container in conversation while streaming or opening conversation
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [dependencies]);

  return (
    <div className="flex-grow overflow-auto" ref={containerRef}>
      {children}
    </div>
  );
};